export enum AnswerKeyMethodEnum {
  Manual = 'manual',
  Scanned = 'scanned',
}
